
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqQsnjWYnCeULhBHdounS2USMOzaIvF5XKux7et_kqY4Meta } from "/codebuild/output/src736706325/src/storefront/pages/index.vue?macro=true";
import { default as loginWluzyb34mqST2FISxZtEHU3_lk9bakwA_8HiFIBjj1sMeta } from "/codebuild/output/src736706325/src/storefront/pages/login.vue?macro=true";
import { default as cookiexry6HPXO7VTju59nJ7JMXejzmSVAG7d71p4AHpseE8cMeta } from "/codebuild/output/src736706325/src/storefront/pages/cookie.vue?macro=true";
import { default as search1pIwX92no3E_45b9EZZdbNsVmzldj8DVoc1ury1IQwB5wMeta } from "/codebuild/output/src736706325/src/storefront/pages/search.vue?macro=true";
import { default as my_45cartm_GbHZRaOhvaQ7lb045NJVFOcMEFtEaA7nm2yP1ZFuIMeta } from "/codebuild/output/src736706325/src/storefront/pages/my-cart.vue?macro=true";
import { default as on_45saleeEEkiJSDJzgHlA_Xxg6fY63GhgdzVEmDrQDmNo52s_454Meta } from "/codebuild/output/src736706325/src/storefront/pages/on-sale.vue?macro=true";
import { default as about_45usZG4X718V0FMbehy6bmMv6JZixbR6vkN4LHS5iGxgOfQMeta } from "/codebuild/output/src736706325/src/storefront/pages/about-us.vue?macro=true";
import { default as book_45club5Kj3158ZiWSWYm_450jLvxkIKZoLrHB45_DcC_n1yyiyoMeta } from "/codebuild/output/src736706325/src/storefront/pages/book-club.vue?macro=true";
import { default as contact_45usi4P4XNZvQAzv6iuCh6Nqb25zi7sst_QL40VEiAapJUMMeta } from "/codebuild/output/src736706325/src/storefront/pages/contact-us.vue?macro=true";
import { default as newspapersdLyz3e82znZ7VKvCEU_45_mVHMY050EwxWhYR7NW5C1zoMeta } from "/codebuild/output/src736706325/src/storefront/pages/newspapers.vue?macro=true";
import { default as _91slug_93sj1A8X99bUCtus5UALBc2_45DwEumcMZurrFzBVzx6y_AMeta } from "/codebuild/output/src736706325/src/storefront/pages/book/[slug].vue?macro=true";
import { default as indexZAZA9PpPCW5Ie61TvKfVGzSkrdGooYKfETCWdLUfOB0Meta } from "/codebuild/output/src736706325/src/storefront/pages/books/index.vue?macro=true";
import { default as barion_45startmsPrIA8l3ZlMXpimkYpHXHv5gXw9uJow0ngaBvPovwQMeta } from "/codebuild/output/src736706325/src/storefront/pages/barion-start.vue?macro=true";
import { default as paypal_45startZ4eDo4w14ghObvjSpy_IxmDW0XOkp62UEvrgmcQQbVcMeta } from "/codebuild/output/src736706325/src/storefront/pages/paypal-start.vue?macro=true";
import { default as _91_46_46_46catchAll_93NQxdA36Ah5EEINufAFAjk3ZIgAlipHZ7onScnLWjSrEMeta } from "/codebuild/output/src736706325/src/storefront/pages/[...catchAll].vue?macro=true";
import { default as indexD4whED9XXjgsB9qKJhybHHv24Q8GlYxsvSZ7DPd7wyAMeta } from "/codebuild/output/src736706325/src/storefront/pages/checkout/index.vue?macro=true";
import { default as payment_45resultjvGsiVtnUkEo5D280Cyz6SSSLtUpx8d_iQ450I82JPkMeta } from "/codebuild/output/src736706325/src/storefront/pages/payment-result.vue?macro=true";
import { default as privacy_45policykffjHURsflA8Fy4DGIsSile5dNAQnXD2TkSZsLITZ1wMeta } from "/codebuild/output/src736706325/src/storefront/pages/privacy-policy.vue?macro=true";
import { default as indexHAVQ189eJwpKjNVyIE8tslTG0JGY8xXJl3qr_45jefSy0Meta } from "/codebuild/output/src736706325/src/storefront/pages/my-orders/index.vue?macro=true";
import { default as newly_45publishedei4s3Qht_njNsPHFWpcbN9zJTqN9rgU_c1TJyblIKBkMeta } from "/codebuild/output/src736706325/src/storefront/pages/newly-published.vue?macro=true";
import { default as _91slug_93BloGmmwmMA6Jvwonm1jAMdpH4ZzQRqfjYQzOHCyEDzwMeta } from "/codebuild/output/src736706325/src/storefront/pages/my-orders/[slug].vue?macro=true";
import { default as thankyouN2DCc4eAbLo221Dnvkl9Nurw688SH2ZeKkkDSOYiytAMeta } from "/codebuild/output/src736706325/src/storefront/pages/checkout/thankyou.vue?macro=true";
import { default as upcoming_45releases3yZaiw4JcLj_gBkmwwWeR4EpZSFBFL4mT5Fnew_45ZDqEMeta } from "/codebuild/output/src736706325/src/storefront/pages/upcoming-releases.vue?macro=true";
import { default as terms_45and_45conditionsTEzvKjXefk_eOjQ0CdS7Noa_45nD4_Rx7RFA5q_ewNWSYMeta } from "/codebuild/output/src736706325/src/storefront/pages/terms-and-conditions.vue?macro=true";
import { default as _91slug_93gFtGEffH_45zRgSXB9RNsMkeO0k4h0OeDCNt6M4XICT_8Meta } from "/codebuild/output/src736706325/src/storefront/pages/other-language/[slug].vue?macro=true";
import { default as indexCAfsY8Tx_45yu5KTNJjcU79S2lq_lJ96brDc189ZGOloQMeta } from "/codebuild/output/src736706325/src/storefront/pages/other-languages/index.vue?macro=true";
import { default as staff_45recommendations2JjP7gMKbM5bxNbUWomqmfAKf7T2y3Jvp2wpKPfAfIEMeta } from "/codebuild/output/src736706325/src/storefront/pages/staff-recommendations.vue?macro=true";
import { default as _91slug_93mNQuCvOuViuuqhIk1QRG_zGziqQ6Lnv1grn5AymqEPkMeta } from "/codebuild/output/src736706325/src/storefront/pages/books-by-author/[slug].vue?macro=true";
import { default as indexeA0R7wD_45GNoJrfj9ksmJn5oZuBrqniP4w_EAL9T5q1sMeta } from "/codebuild/output/src736706325/src/storefront/pages/books/[category]/index.vue?macro=true";
import { default as _91slug_93oSc_H0PEFseZKWzpiz0owLwX5kW_45NJ_45IwFEFEcNLyG8Meta } from "/codebuild/output/src736706325/src/storefront/pages/menu-navigation/[slug].vue?macro=true";
import { default as bestsellers_45of_45the_45monthTsEK_gVOqVrzCN0BpDAH7yIyuRvBIK6LlB58V9RbGvIMeta } from "/codebuild/output/src736706325/src/storefront/pages/bestsellers-of-the-month.vue?macro=true";
import { default as _91slug_93s_PqOUQJPciWXNGkcDiGVZ1q9Xh9wIgkSA5XTeoTExIMeta } from "/codebuild/output/src736706325/src/storefront/pages/stationary-and-gift/[slug].vue?macro=true";
import { default as indexIqmZibLLMVd8rzWMC4kfN1mDomNaMpEYaCCStEwF1v8Meta } from "/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/index.vue?macro=true";
import { default as indexAsfXddPSAmfDLBI8eOWgI2gBdOwBtjcx1tKehRdkahAMeta } from "/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/index.vue?macro=true";
import { default as purchase_45and_45shipping_45conditionsQ_45bW3XFjfZ_45lKGQL6YwzXzB5NHMr9KRdt_JGqmH4hZAMeta } from "/codebuild/output/src736706325/src/storefront/pages/purchase-and-shipping-conditions.vue?macro=true";
import { default as indexL4zMuDQ_aUR3CRvpaCXzR5vNdeXgyFv3i4C5WuwPdAAMeta } from "/codebuild/output/src736706325/src/storefront/pages/books/[category]/[subcategory]/index.vue?macro=true";
import { default as _91_91subcategory_93_93ZhPFhYfx0OAMuAUJe6yIpwDoAyXQytxc1J8wAKbz_45b4Meta } from "/codebuild/output/src736706325/src/storefront/pages/products/[[category]]/[[subcategory]].vue?macro=true";
import { default as indexvFh3fD0Li3bov2hbCwQv_N3TxXLLu6IdHhmagxq5oqMMeta } from "/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/index.vue?macro=true";
import { default as indexTYYAyh5dNjL9UQc7sDw4nWa8_45S5wZdrwv1w374JxlL4Meta } from "/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue?macro=true";
import { default as indexXwPkszbVpN6i7mtaSQ0DwowSxc_YcyrDE_45hbyiIa1foMeta } from "/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue?macro=true";
export default [
  {
    name: "index___hu",
    path: "/hu",
    meta: indexqQsnjWYnCeULhBHdounS2USMOzaIvF5XKux7et_kqY4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexqQsnjWYnCeULhBHdounS2USMOzaIvF5XKux7et_kqY4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/index.vue")
  },
  {
    name: "login___hu",
    path: "/hu/bejelentkezes",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/login.vue")
  },
  {
    name: "cookie___hu",
    path: "/hu/suti",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/cookie.vue")
  },
  {
    name: "cookie___en",
    path: "/cookie",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/cookie.vue")
  },
  {
    name: "search___hu",
    path: "/hu/kereses",
    meta: search1pIwX92no3E_45b9EZZdbNsVmzldj8DVoc1ury1IQwB5wMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: search1pIwX92no3E_45b9EZZdbNsVmzldj8DVoc1ury1IQwB5wMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/search.vue")
  },
  {
    name: "my-cart___hu",
    path: "/hu/kosaram",
    meta: my_45cartm_GbHZRaOhvaQ7lb045NJVFOcMEFtEaA7nm2yP1ZFuIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-cart.vue")
  },
  {
    name: "my-cart___en",
    path: "/my-cart",
    meta: my_45cartm_GbHZRaOhvaQ7lb045NJVFOcMEFtEaA7nm2yP1ZFuIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-cart.vue")
  },
  {
    name: "on-sale___hu",
    path: "/hu/akciok",
    meta: on_45saleeEEkiJSDJzgHlA_Xxg6fY63GhgdzVEmDrQDmNo52s_454Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/on-sale.vue")
  },
  {
    name: "on-sale___en",
    path: "/on-sale",
    meta: on_45saleeEEkiJSDJzgHlA_Xxg6fY63GhgdzVEmDrQDmNo52s_454Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/on-sale.vue")
  },
  {
    name: "about-us___hu",
    path: "/hu/rolunk",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/about-us.vue")
  },
  {
    name: "book-club___hu",
    path: "/hu/konyvklub",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/book-club.vue")
  },
  {
    name: "book-club___en",
    path: "/book-club",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/book-club.vue")
  },
  {
    name: "contact-us___hu",
    path: "/hu/kapcsolat",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/contact-us.vue")
  },
  {
    name: "newspapers___hu",
    path: "/hu/ujsagok-es-magazinok",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/newspapers.vue")
  },
  {
    name: "newspapers___en",
    path: "/newspapers-and-magazines",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/newspapers.vue")
  },
  {
    name: "book-slug___hu",
    path: "/hu/konyv/:slug()",
    meta: _91slug_93sj1A8X99bUCtus5UALBc2_45DwEumcMZurrFzBVzx6y_AMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "book-slug___en",
    path: "/book/:slug()",
    meta: _91slug_93sj1A8X99bUCtus5UALBc2_45DwEumcMZurrFzBVzx6y_AMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "books___hu",
    path: "/hu/konyvek",
    meta: indexZAZA9PpPCW5Ie61TvKfVGzSkrdGooYKfETCWdLUfOB0Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/index.vue")
  },
  {
    name: "books___en",
    path: "/books",
    meta: indexZAZA9PpPCW5Ie61TvKfVGzSkrdGooYKfETCWdLUfOB0Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/index.vue")
  },
  {
    name: "barion-start___hu",
    path: "/hu/barion-fizetes",
    meta: { ...(barion_45startmsPrIA8l3ZlMXpimkYpHXHv5gXw9uJow0ngaBvPovwQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/barion-start.vue")
  },
  {
    name: "barion-start___en",
    path: "/barion-start",
    meta: { ...(barion_45startmsPrIA8l3ZlMXpimkYpHXHv5gXw9uJow0ngaBvPovwQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/barion-start.vue")
  },
  {
    name: "paypal-start___hu",
    path: "/hu/paypal-fizetes",
    meta: { ...(paypal_45startZ4eDo4w14ghObvjSpy_IxmDW0XOkp62UEvrgmcQQbVcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "paypal-start___en",
    path: "/paypal-start",
    meta: { ...(paypal_45startZ4eDo4w14ghObvjSpy_IxmDW0XOkp62UEvrgmcQQbVcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "catchAll___hu",
    path: "/hu/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93NQxdA36Ah5EEINufAFAjk3ZIgAlipHZ7onScnLWjSrEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "catchAll___en",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93NQxdA36Ah5EEINufAFAjk3ZIgAlipHZ7onScnLWjSrEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "checkout___hu",
    path: "/hu/megrendeles",
    meta: { ...(indexD4whED9XXjgsB9qKJhybHHv24Q8GlYxsvSZ7DPd7wyAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: { ...(indexD4whED9XXjgsB9qKJhybHHv24Q8GlYxsvSZ7DPd7wyAMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "payment-result___hu",
    path: "/hu/barion-eredmeny",
    meta: { ...(payment_45resultjvGsiVtnUkEo5D280Cyz6SSSLtUpx8d_iQ450I82JPkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/payment-result.vue")
  },
  {
    name: "payment-result___en",
    path: "/barion-result",
    meta: { ...(payment_45resultjvGsiVtnUkEo5D280Cyz6SSSLtUpx8d_iQ450I82JPkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/payment-result.vue")
  },
  {
    name: "privacy-policy___hu",
    path: "/hu/adatkezelesi-tajekoztato",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "my-orders___hu",
    path: "/hu/rendeleseim",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "my-orders___en",
    path: "/my-orders",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "newly-published___hu",
    path: "/hu/ujdonsagok",
    meta: newly_45publishedei4s3Qht_njNsPHFWpcbN9zJTqN9rgU_c1TJyblIKBkMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/newly-published.vue")
  },
  {
    name: "newly-published___en",
    path: "/newly-published",
    meta: newly_45publishedei4s3Qht_njNsPHFWpcbN9zJTqN9rgU_c1TJyblIKBkMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/newly-published.vue")
  },
  {
    name: "my-orders-slug___hu",
    path: "/hu/rendeleseim/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "my-orders-slug___en",
    path: "/my-orders/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "checkout-thankyou___hu",
    path: "/hu/megrendeles-koszonjuk",
    meta: thankyouN2DCc4eAbLo221Dnvkl9Nurw688SH2ZeKkkDSOYiytAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/checkout-thankyou",
    meta: thankyouN2DCc4eAbLo221Dnvkl9Nurw688SH2ZeKkkDSOYiytAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "upcoming-releases___hu",
    path: "/hu/varhato-megjelenesek",
    meta: upcoming_45releases3yZaiw4JcLj_gBkmwwWeR4EpZSFBFL4mT5Fnew_45ZDqEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "upcoming-releases___en",
    path: "/upcoming-releases",
    meta: upcoming_45releases3yZaiw4JcLj_gBkmwwWeR4EpZSFBFL4mT5Fnew_45ZDqEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "terms-and-conditions___hu",
    path: "/hu/altalanos-szerzodesi-feltetelek",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "other-language-slug___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyv/:slug()",
    meta: _91slug_93gFtGEffH_45zRgSXB9RNsMkeO0k4h0OeDCNt6M4XICT_8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-language-slug___en",
    path: "/other-language/:slug()",
    meta: _91slug_93gFtGEffH_45zRgSXB9RNsMkeO0k4h0OeDCNt6M4XICT_8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-languages___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek",
    meta: indexCAfsY8Tx_45yu5KTNJjcU79S2lq_lJ96brDc189ZGOloQMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "other-languages___en",
    path: "/other-languages",
    meta: indexCAfsY8Tx_45yu5KTNJjcU79S2lq_lJ96brDc189ZGOloQMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "staff-recommendations___hu",
    path: "/hu/mi-ajanljuk",
    meta: staff_45recommendations2JjP7gMKbM5bxNbUWomqmfAKf7T2y3Jvp2wpKPfAfIEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "staff-recommendations___en",
    path: "/staff-recommendations",
    meta: staff_45recommendations2JjP7gMKbM5bxNbUWomqmfAKf7T2y3Jvp2wpKPfAfIEMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "books-by-author-slug___hu",
    path: "/hu/szerzo-muvei/:slug()",
    meta: _91slug_93mNQuCvOuViuuqhIk1QRG_zGziqQ6Lnv1grn5AymqEPkMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-by-author-slug___en",
    path: "/books-by-author/:slug()",
    meta: _91slug_93mNQuCvOuViuuqhIk1QRG_zGziqQ6Lnv1grn5AymqEPkMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-category___hu",
    path: "/hu/konyvek/:category()",
    meta: indexeA0R7wD_45GNoJrfj9ksmJn5oZuBrqniP4w_EAL9T5q1sMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "books-category___en",
    path: "/books/:category()",
    meta: indexeA0R7wD_45GNoJrfj9ksmJn5oZuBrqniP4w_EAL9T5q1sMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "menu-navigation-slug___hu",
    path: "/hu/menu-navigacio/:slug()",
    meta: _91slug_93oSc_H0PEFseZKWzpiz0owLwX5kW_45NJ_45IwFEFEcNLyG8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "menu-navigation-slug___en",
    path: "/menu-navigation/:slug()",
    meta: _91slug_93oSc_H0PEFseZKWzpiz0owLwX5kW_45NJ_45IwFEFEcNLyG8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "bestsellers-of-the-month___hu",
    path: "/hu/a-honap-sikerkonyvei",
    meta: bestsellers_45of_45the_45monthTsEK_gVOqVrzCN0BpDAH7yIyuRvBIK6LlB58V9RbGvIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "bestsellers-of-the-month___en",
    path: "/bestsellers-of-the-month",
    meta: bestsellers_45of_45the_45monthTsEK_gVOqVrzCN0BpDAH7yIyuRvBIK6LlB58V9RbGvIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "stationary-and-gift-slug___hu",
    path: "/hu/notesz-es-ajandektargy/:slug()",
    meta: _91slug_93s_PqOUQJPciWXNGkcDiGVZ1q9Xh9wIgkSA5XTeoTExIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gift-slug___en",
    path: "/stationary-and-gift/:slug()",
    meta: _91slug_93s_PqOUQJPciWXNGkcDiGVZ1q9Xh9wIgkSA5XTeoTExIMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gifts___hu",
    path: "/hu/noteszek-es-ajandektargyak",
    meta: indexIqmZibLLMVd8rzWMC4kfN1mDomNaMpEYaCCStEwF1v8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "stationary-and-gifts___en",
    path: "/stationary-and-gifts",
    meta: indexIqmZibLLMVd8rzWMC4kfN1mDomNaMpEYaCCStEwF1v8Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "other-languages-category___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:category()",
    meta: indexAsfXddPSAmfDLBI8eOWgI2gBdOwBtjcx1tKehRdkahAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "other-languages-category___en",
    path: "/other-languages/:category()",
    meta: indexAsfXddPSAmfDLBI8eOWgI2gBdOwBtjcx1tKehRdkahAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "purchase-and-shipping-conditions___hu",
    path: "/hu/vasarlasi-es-szallitasi-feltetelek",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "purchase-and-shipping-conditions___en",
    path: "/purchase-and-shipping-conditions",
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "books-category-subcategory___hu",
    path: "/hu/konyvek/:category()/:subcategory()",
    meta: indexL4zMuDQ_aUR3CRvpaCXzR5vNdeXgyFv3i4C5WuwPdAAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "books-category-subcategory___en",
    path: "/books/:category()/:subcategory()",
    meta: indexL4zMuDQ_aUR3CRvpaCXzR5vNdeXgyFv3i4C5WuwPdAAMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "products-category-subcategory___hu",
    path: "/hu/product/:category?/:subcategory?",
    meta: _91_91subcategory_93_93ZhPFhYfx0OAMuAUJe6yIpwDoAyXQytxc1J8wAKbz_45b4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "products-category-subcategory___en",
    path: "/products/:category?/:subcategory?",
    meta: _91_91subcategory_93_93ZhPFhYfx0OAMuAUJe6yIpwDoAyXQytxc1J8wAKbz_45b4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "stationary-and-gifts-category___hu",
    path: "/hu/noteszek-es-ajandektargyak/:category()",
    meta: indexvFh3fD0Li3bov2hbCwQv_N3TxXLLu6IdHhmagxq5oqMMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "stationary-and-gifts-category___en",
    path: "/stationary-and-gifts/:category()",
    meta: indexvFh3fD0Li3bov2hbCwQv_N3TxXLLu6IdHhmagxq5oqMMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:categorysubcategory?",
    meta: indexTYYAyh5dNjL9UQc7sDw4nWa8_45S5wZdrwv1w374JxlL4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___en",
    path: "/other-languages/:category()/:subcategory()",
    meta: indexTYYAyh5dNjL9UQc7sDw4nWa8_45S5wZdrwv1w374JxlL4Meta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___hu",
    path: "/hu/noteszek-es-ajandektargyak/:categorysubcategory?",
    meta: indexXwPkszbVpN6i7mtaSQ0DwowSxc_YcyrDE_45hbyiIa1foMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___en",
    path: "/stationary-and-gifts/:category()/:subcategory()",
    meta: indexXwPkszbVpN6i7mtaSQ0DwowSxc_YcyrDE_45hbyiIa1foMeta || {},
    component: () => import("/codebuild/output/src736706325/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  }
]